import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Flex,
  Form,
  Input,
  Radio,
  Row,
} from "antd";
import React, { useState } from "react";
import { Content } from "antd/es/layout/layout";
import "./style.css";
import api from "../../api";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import LoadingOverlay from "react-loading-overlay";
const { TextArea } = Input;

const Register = ({ setActive }) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [secBuyer, setSecBuyer] = useState(false);
  const [thirdBuyer, setThirdBuyer] = useState(false);
  const [secSeller, setSecSeller] = useState(false);
  const [thirdSeller, setThirdSeller] = useState(false);
  const [waiveMortgage, setWaiveMortgage] = useState(false);
  const [waiveinspection, setWaiveinspection] = useState(false);
  const [escalation, setEsclation] = useState(false);
  const [representation, setRepresentation] = useState(false);
  const [addAddendum, setAddAddendum] = useState(false);
  const [paymentOfEscalatedPrice, setPaymentOfEscalatedPrice] = useState(null);
  const [satisfactoryVal, setSatisfactoryVal] = useState(null);
  const [offDeposit, setOffDeposit] = useState(null);
  const [compensation, setCompensation] = useState("percentage");
  const [additionalComp, setAdditionalComp] = useState(null);
  const [sign, setSign] = useState(null);
  const [date, setDate] = useState(moment().set({ hour: 12, minute: 0 })); // Default to 12 PM
  const radioValue = Form.useWatch("radio5", form);
  const onHandleSubmit = async (values) => {
    setActive(true);
    values.waiveMortgage = waiveMortgage;
    values.waiveinspection = waiveinspection;
    values.paymentOfEscalatedPrice = paymentOfEscalatedPrice;
    values.addAddendum = addAddendum;
    if (radioValue == "independent_compensation") {
      values.additonal_cost_compensation = `${values.additonal_cost_compensation}${values.cost_type}`;
    }
    console.log(values);
    // let res = await api.post("/formValues", values);
    let res = await fetch(`${process.env.REACT_APP_BASE_URL}/api/formValues`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(values),
    });
    debugger;

    console.log(res);
    const { pdfBase64 } = await res.json();
    const byteCharacters = atob(pdfBase64);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(null)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    console.log("url", url);
    // Create a link element to download the PDF
    const a = document.createElement("a");
    a.href = url;
    a.download = "Offer Package Report"; // Set the desired file name
    document.body.appendChild(a);
    a.click();

    // Clean up
    a.remove();
    window.URL.revokeObjectURL(url);
    setActive(false);
  };

  const onChangeWaiveMortage = (event) => {
    setWaiveMortgage(event.target.checked);
  };
  const onChangeWaiveinspection = (event) => {
    setWaiveinspection(event.target.checked);
  };

  const handleChangepaymentOfEsc = (e, value) => {
    if (e.target.checked) {
      setPaymentOfEscalatedPrice(value);
    } else {
      setPaymentOfEscalatedPrice(null);
    }
  };

  const onChangeSatisfactory = (e) => {
    setSatisfactoryVal(e.target.value);
  };

  const onChangeCompensation = (e) => {
    setAdditionalComp(e.target.value);
  };

  const onChangeSign = (e) => {
    setSign(e.target.value);
  };

  return (
    <Content style={{ height: "100vh", padding: "12px" }}>
      <div className="main">
        <Form
          className="signup-form"
          onFinish={onHandleSubmit}
          form={form}
          layout="vertical"
          name="offerForm"
        >
          <div className="fieldMain">
            <div className={`field ${secBuyer ? "" : "mtMinus"}`}>
              <div>
                <div className="plusHeader">
                  {(!secBuyer || !thirdBuyer) && (
                    <div
                      className="plus"
                      onClick={() => {
                        if (!secBuyer) {
                          setSecBuyer(true);
                        } else {
                          setThirdBuyer(true);
                        }
                      }}
                    >
                      +
                    </div>
                  )}
                  <label className="form-title" for="buyerName">
                    Buyer(s) Full Name
                  </label>
                </div>
                <Form.Item
                  name="buyerName"
                  rules={[{ required: true, message: "required!" }]}
                >
                  <Input
                    className="input"
                    placeholder="Enter Full Name"
                    autoComplete="off"
                  />
                </Form.Item>
              </div>
              {secBuyer && (
                <Form.Item
                  name="buyerName2"
                  rules={[{ required: true, message: "required!" }]}
                >
                  <Input
                    className="input"
                    placeholder="Enter Full Name"
                    autoComplete="off"
                  />
                </Form.Item>
              )}
              {thirdBuyer && (
                <Form.Item
                  name="buyerName3"
                  rules={[{ required: true, message: "required!" }]}
                >
                  <Input
                    className="input"
                    placeholder="Enter Full Name"
                    autoComplete="off"
                  />
                </Form.Item>
              )}
            </div>
            <div className="field">
              <div>
                <label className="form-title" for="buyerAddress">
                  Buyer(s) Address
                </label>
                <Form.Item
                  name="buyerAddress"
                  rules={[{ required: true, message: "required!" }]}
                >
                  <Input
                    className="input"
                    placeholder="Enter Address"
                    autoComplete="off"
                  />
                </Form.Item>
              </div>
              {secBuyer && (
                <Form.Item
                  name="buyerAddress2"
                  rules={[{ required: true, message: "required!" }]}
                >
                  <Input
                    className="input"
                    placeholder="Enter Address"
                    autoComplete="off"
                  />
                </Form.Item>
              )}

              {thirdBuyer && (
                <Form.Item
                  name="buyerAddress3"
                  rules={[{ required: true, message: "required!" }]}
                >
                  <Input
                    className="input"
                    placeholder="Enter Address"
                    autoComplete="off"
                  />
                </Form.Item>
              )}
            </div>
          </div>

          <div className="fieldMain">
            <div className={`field ${secSeller ? "" : "mtMinus"}`}>
              <div>
                <div className="plusHeader">
                  {(!secSeller || !thirdSeller) && (
                    <div
                      className="plus"
                      onClick={() => {
                        if (!secSeller) {
                          setSecSeller(true);
                        } else {
                          setThirdSeller(true);
                        }
                      }}
                    >
                      +
                    </div>
                  )}

                  <label className="form-title" for="sellerName">
                    Seller(s) Full Name
                  </label>
                </div>
                <Form.Item
                  name="sellerName"
                  rules={[{ required: true, message: "required!" }]}
                >
                  <Input
                    className="input"
                    placeholder="Enter Full Name"
                    autoComplete="off"
                  />
                </Form.Item>
              </div>
              {secSeller && (
                <Form.Item
                  name="sellerName2"
                  rules={[{ required: true, message: "required!" }]}
                >
                  <Input
                    className="input"
                    placeholder="Enter Full Name"
                    autoComplete="off"
                  />
                </Form.Item>
              )}
              {thirdSeller && (
                <Form.Item
                  name="sellerName3"
                  rules={[{ required: true, message: "required!" }]}
                >
                  <Input
                    className="input"
                    placeholder="Enter Full Name"
                    autoComplete="off"
                  />
                </Form.Item>
              )}
            </div>
            <div className="field">
              <div>
                <label className="form-title" for="sellerAddress">
                  Seller(s) Address
                </label>
                <Form.Item
                  name="sellerAddress"
                  rules={[{ required: true, message: "required!" }]}
                >
                  <Input
                    className="input"
                    placeholder="Enter Address"
                    autoComplete="off"
                  />
                </Form.Item>
              </div>
              {secSeller && (
                <Form.Item
                  name="sellerAddress2"
                  rules={[{ required: true, message: "required!" }]}
                >
                  <Input
                    className="input"
                    placeholder="Enter Address"
                    autoComplete="off"
                  />
                </Form.Item>
              )}
              {thirdSeller && (
                <Form.Item
                  name="sellerAddress3"
                  rules={[{ required: true, message: "required!" }]}
                >
                  <Input
                    className="input"
                    placeholder="Enter Address"
                    autoComplete="off"
                  />
                </Form.Item>
              )}
            </div>
          </div>
          <hr />

          <div className="fieldMain">
            <div className="field">
              <label className="form-title" for="agentFullName">
                Agent Full Name
              </label>
              <Form.Item
                name="agentFullName"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input
                  className="input"
                  placeholder="Enter Full Name"
                  autoComplete="off"
                />
              </Form.Item>
            </div>
            <div className="field">
              <label className="form-title" for="agentLicenseNumber">
                Agent License Number
              </label>
              <Form.Item
                name="agentLicenseNumber"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input
                  className="input"
                  placeholder="Enter License Number"
                  autoComplete="off"
                />
              </Form.Item>
            </div>
            <div className="field">
              <label className="form-title" for="agentBrokerage">
                Agent Brokerage
              </label>
              <Form.Item
                name="agentBrokerage"
                rules={[{ required: true, message: "required!" }]}
                initialValue={"Vicente Realty, LLC"}
              >
                <Input
                  className="input"
                  // placeholder="Enter address"
                  autoComplete="off"
                  disabled={true}
                />
              </Form.Item>
            </div>
            <div className="field">
              <label className="form-title" for="brokerageLicenseNumber">
                Brokerage License Number
              </label>
              <Form.Item
                name="brokerageLicenseNumber"
                rules={[{ required: true, message: "required!" }]}
                initialValue="9799"
              >
                <Input
                  className="input"
                  // placeholder="Enter address"
                  autoComplete="off"
                  disabled
                />
              </Form.Item>
            </div>
          </div>

          <div className="radioMain">
            <Form.Item
              // label="radio"
              name="radio1"
              rules={[{ required: true, message: "required!" }]}
              initialValue="Broker"
            >
              <Radio.Group
                style={{
                  display: "flex",
                  flexDirection: "column",
                  columnGap: "1rem",
                }}
                defaultValue="Broker"
              >
                <Radio value="Salesperson">Salesperson</Radio>
                <Radio value="Broker">Broker</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              // label="radio"
              name="radio2"
              rules={[{ required: true, message: "required!" }]}
              initialValue="Designated Agency"
            >
              <Radio.Group
                style={{
                  display: "flex",
                  flexDirection: "column",
                  columnGap: "1rem",
                }}
                defaultValue="Designated Agency"
              >
                <Radio value="Non-Designated Agency">
                  Non-Designated Agency
                </Radio>
                <Radio value="Designated Agency">Designated Agency</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              // label="radio"
              name="radio3"
              rules={[{ required: true, message: "required!" }]}
            >
              <Radio.Group>
                <Radio value="Buyer's agent">Buyer's agent</Radio>
                <Radio value="Seller's agent">Seller's agent</Radio>
                <Radio value="Facilitator">Facilitator</Radio>
                <Radio value="Dual agent">Dual agent</Radio>
              </Radio.Group>
            </Form.Item>
          </div>

          <hr />

          <div className="fieldMain">
            <div className="field">
              <label className="form-title" for="sellerBrokerage">
                Seller's Brokerage
              </label>
              <Form.Item
                name="sellerBrokerage"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input
                  className="input"
                  placeholder="Enter Seller Brokerage"
                  autoComplete="off"
                />
              </Form.Item>
            </div>
            <div className="field">
              <label className="form-title" for="propertyAddress">
                Property Address
              </label>
              <Form.Item
                name="propertyAddress"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input
                  className="input"
                  placeholder="Enter Property Address"
                  autoComplete="off"
                />
              </Form.Item>
            </div>
          </div>
          <hr />

          <div className="fieldMain">
            <div className="field">
              <label className="form-title" for="purchasePrice">
                Purchase Price
              </label>
              <Form.Item
                name="purchasePrice"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input
                  className="input"
                  placeholder="Enter offer amount"
                  autoComplete="off"
                />
              </Form.Item>
            </div>
            <div className="field">
              <label className="form-title" for="offerDeposit">
                Offer Deposit
              </label>
              <Form.Item
                name="offerDeposit"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input
                  className="input"
                  placeholder="Enter offer deposit amount"
                  autoComplete="off"
                  onChange={(e) => setOffDeposit(e.target.value)}
                />
              </Form.Item>

              {offDeposit && (
                <Form.Item
                  name="offerDepositCheck"
                  rules={[{ required: true, message: "required!" }]}
                >
                  <Radio.Group>
                    <Radio value="seller_agent">
                      With seller or seller's agent
                    </Radio>
                    <Radio value="delivered_with_receipt">
                      Delivered with receipt of written acceptance
                    </Radio>
                  </Radio.Group>
                </Form.Item>
              )}
            </div>
            <div className="field">
              <label className="form-title" for="Purchase&SaleDeposit">
                Purchase & Sale Deposit
              </label>
              <Form.Item
                name="Purchase&SaleDeposit"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input
                  className="input"
                  placeholder="Enter deposit amount"
                  autoComplete="off"
                />
              </Form.Item>
            </div>
          </div>

          <div className="fieldMain">
            <div className="field">
              <label className="form-title" for="offerExpirationDate">
                Offer Expiration Date
              </label>
              <Form.Item
                name="offerExpirationDate"
                rules={[{ required: true, message: "required!" }]}
              >
                <DatePicker
                  inputReadOnly
                  placeholder={"Select date"}
                  showTime={{
                    format: "hh",
                    use12Hours: true,
                  }}
                  format="YYYY-MM-DD HH"
                  onChange={(value, dateString) => {
                    // Send ISO string to backend
                    let localDate = value ? value.toISOString() : null;
                    console.log(localDate, new Date(localDate).getHours()); // This will show the date in the local timezone

                    localDate = moment(date).format("YYYY-MM-DD HH"); // Retain local timezone
                    console.log(localDate);
                  }}
                />
              </Form.Item>
            </div>
            <div className="field">
              <label className="form-title" for="purchaseAndsaleDate">
                Purchase & Sale Date
              </label>
              <Form.Item
                name="purchaseAndsaleDate"
                rules={[{ required: true, message: "required!" }]}
              >
                <DatePicker
                  inputReadOnly
                  placeholder={"Select Purchase & sale date"}
                  showTime={{
                    format: "hh",
                    use12Hours: true,
                  }}
                  format="YYYY-MM-DD HH"
                />
              </Form.Item>
            </div>
            <div className="field">
              <label className="form-title" for="Closing date">
                Closing Date
              </label>
              <Form.Item
                name="closingDate"
                rules={[{ required: true, message: "required!" }]}
              >
                <DatePicker
                  inputReadOnly
                  placeholder={"Select Closing date"}
                  showTime={{
                    format: "hh",
                    use12Hours: true,
                  }}
                  format="YYYY-MM-DD HH"
                />
              </Form.Item>
            </div>
            <div className="field">
              <label className="form-title" for="closingCounty">
                Closing County
              </label>
              <Form.Item
                name="closingCounty"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input
                  className="input"
                  placeholder="Enter county name"
                  autoComplete="off"
                />
              </Form.Item>
            </div>
          </div>
          <hr />

          <div>
            <label className="form-title" for="escrowAgent">
              Escrow Agent
            </label>
            <Form.Item
              name="escrowAgent"
              rules={[{ required: true, message: "required!" }]}
            >
              <Input
                className="input"
                placeholder="Enter escrow agent"
                autoComplete="off"
              />
            </Form.Item>
          </div>

          <div className="fieldMain">
            <div className="field">
              <Checkbox onChange={onChangeWaiveMortage}>
                Waive Mortgage Contingency
              </Checkbox>
            </div>
            {!waiveMortgage && (
              <>
                <div className="field">
                  <label className="form-title" for="mortgageAmount">
                    Mortgage amount
                  </label>
                  <Form.Item
                    name="mortgageAmount"
                    rules={[{ required: true, message: "required!" }]}
                  >
                    <Input
                      className="input"
                      placeholder="Enter Mortgage amount"
                      autoComplete="off"
                    />
                  </Form.Item>
                </div>
                <div className="field">
                  <label className="form-title" for="mortgageCommitmentDate">
                    Mortgage Commitment date
                  </label>
                  <Form.Item
                    name="mortgageCommitmentDate"
                    rules={[{ required: true, message: "required!" }]}
                  >
                    <DatePicker
                      inputReadOnly
                      showTime={{
                        format: "hh",
                        use12Hours: true,
                      }}
                      format="YYYY-MM-DD HH"
                    />
                  </Form.Item>
                </div>
                <div className="field">
                  <label className="form-title" for="mortgageApplicationDate">
                    Mortgage Application Date
                  </label>
                  <Form.Item
                    name="mortgageApplicationDate"
                    rules={[{ required: true, message: "required!" }]}
                  >
                    <DatePicker
                      inputReadOnly
                      showTime={{
                        format: "hh",
                        use12Hours: true,
                      }}
                      format="YYYY-MM-DD HH"
                    />
                  </Form.Item>
                </div>
              </>
            )}
          </div>

          <div className="fieldMain">
            <div style={{ width: "23%", fontSize: 19, marginLeft: 22 }}>
              {/* <Checkbox onChange={onChangeWaiveinspection}> */}
              Inspection
              {/* </Checkbox> */}
            </div>
            {/* {!waiveinspection && ( */}
            <div style={{ width: "60%" }}>
              <label className="form-title" for="inspectionDate">
                Inspection date
              </label>
              <Form.Item
                name="inspectionDate"
                rules={[{ required: true, message: "required!" }]}
              >
                <DatePicker
                  inputReadOnly
                  showTime={{
                    format: "HH", // 24-hour format
                    use12Hours: true, //
                    // defaultValue: moment().set({ hour: 12, minute: 0 }), // Set default to 12 PM
                  }}
                  format="YYYY-MM-DD HH"
                />
              </Form.Item>
              <div>
                <label className="form-title" for="radio4">
                  If the Result are not satisfactory to the BUYER (Choose one)
                </label>
                <Form.Item
                  // label="radio"
                  name="radio4"
                  rules={[{ required: true, message: "required!" }]}
                  initialValue="Broker"
                >
                  <Radio.Group
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      columnGap: "1rem",
                    }}
                    onChange={onChangeSatisfactory}
                  >
                    <Radio value="buyer_sole_discretion">
                      In BUYER'S sole discretion,
                    </Radio>
                    <Radio value="estimated_aggregate">
                      The estimated aggregate cost of repairs exceeds{" "}
                    </Radio>
                  </Radio.Group>
                </Form.Item>
                {satisfactoryVal == "estimated_aggregate" && (
                  <Form.Item
                    name="estimated_cost"
                    rules={[{ required: true, message: "Required" }]}
                  >
                    <Input
                      placeholder="Enter Cost"
                      prefix="$"
                      style={{ width: "30%" }}
                    />
                  </Form.Item>
                )}
                {satisfactoryVal == "estimated_aggregate" && (
                  <Form.Item
                    name="additional_provisions"
                    rules={[{ required: true, message: "Required" }]}
                  >
                    <TextArea
                      rows={2}
                      placeholder="Enter Additional Provisions"
                    />
                  </Form.Item>
                )}
              </div>
            </div>
            {/* )} */}
          </div>
          <hr />
          {/* <Checkbox
            onChange={(e) => setEsclation(e.target.checked)}
            style={{ marginBottom: "5px" }}
          >
            Escalation Clause
          </Checkbox>
          {escalation && (
            <>
              <div className="fieldMain">
                <div className="field">
                  <label className="form-title" for="escalationAmount">
                    Escalation Amount
                  </label>
                  <Form.Item
                    name="escalationAmount"
                    rules={[{ required: true, message: "required!" }]}
                  >
                    <Input
                      className="input"
                      placeholder="Enter Escalation Amount"
                      autoComplete="off"
                    />
                  </Form.Item>
                </div>
                <div className="field">
                  <label className="form-title" for="maximumPrice">
                    Maximum Price
                  </label>
                  <Form.Item
                    name="maximumPrice"
                    rules={[{ required: true, message: "required!" }]}
                  >
                    <Input
                      className="input"
                      placeholder="Enter Maximum Price"
                      autoComplete="off"
                    />
                  </Form.Item>
                </div>
              </div>
              <hr />
              {(paymentOfEscalatedPrice ==
                "Buyer shall pay the entire escalation" ||
                !paymentOfEscalatedPrice) && (
                <div className="fieldMain">
                  <div style={{ width: "40%", marginBottom: "1.4rem" }}>
                    <Checkbox
                      onChange={(e) =>
                        handleChangepaymentOfEsc(
                          e,
                          "Buyer shall pay the entire escalation"
                        )
                      }
                    >
                      Buyer shall pay the entire escalation increase in cash
                    </Checkbox>
                  </div>
                </div>
              )}

              <div className="fieldMain">
                {(paymentOfEscalatedPrice ==
                  "Loan Amount in the financing contingency" ||
                  !paymentOfEscalatedPrice) && (
                  <>
                    <div style={{ width: "28%" }}>
                      <Checkbox
                        onChange={(e) =>
                          handleChangepaymentOfEsc(
                            e,
                            "Loan Amount in the financing contingency"
                          )
                        }
                      >
                        Loan Amount in the financing contingency
                      </Checkbox>
                    </div>
                    <div>
                      <label className="form-title" for="loanAmount">
                        Loan Amount
                      </label>
                      <Form.Item
                        name="loanAmount"
                        rules={[{ required: true, message: "required!" }]}
                      >
                        <Input
                          className="input"
                          placeholder="Enter Loan Amount"
                          autoComplete="off"
                        />
                      </Form.Item>
                    </div>
                  </>
                )}
              </div>
              {(paymentOfEscalatedPrice ==
                "Increased purchase price shall be divided" ||
                !paymentOfEscalatedPrice) && (
                <div className="fieldMain">
                  <div style={{ width: "28%" }}>
                    <Checkbox
                      onChange={(e) =>
                        handleChangepaymentOfEsc(
                          e,
                          "Increased purchase price shall be divided"
                        )
                      }
                    >
                      Increased purchase price shall be divided
                    </Checkbox>
                  </div>
                  <div>
                    <label className="form-title" for="increasedPurchasePrice">
                      Increased purchase price
                    </label>
                    <Form.Item
                      name="increasedPurchasePrice"
                      rules={[{ required: true, message: "required!" }]}
                    >
                      <Input
                        className="input"
                        placeholder="Enter Increased purchase price"
                        autoComplete="off"
                      />
                    </Form.Item>
                  </div>
                </div>
              )}
            </>
          )} */}

          {/* <hr /> */}

          <div style={{ display: "flex", columnGap: "1rem" }}>
            <div>
              <label className="form-title" for="Compensation to Buyer Broker">
                Compensation to Buyer Broker
              </label>
              <Form.Item
                name="compensation_to_buyer"
                rules={[{ required: true, message: "required!" }]}
                initialValue="percentage"
              >
                <Radio.Group
                  onChange={(e) => setCompensation(e.target.value)}
                  defaultValue="percentage"
                >
                  <Radio value="percentage">Percentage</Radio>
                  {/* <Radio value="flatFee">Flat Fee</Radio> */}
                </Radio.Group>
              </Form.Item>
            </div>

            {compensation == "percentage" ? (
              <div>
                <Form.Item
                  name="percentage"
                  rules={[{ required: true, message: "required!" }]}
                >
                  <Input placeholder="Enter Percentage" />
                </Form.Item>
                <Form.Item
                  name="percentagePoint"
                  rules={[{ required: true, message: "required!" }]}
                >
                  <Radio.Group>
                    <Radio value="net">Net</Radio>
                    <Radio value="gross">Gross</Radio>
                  </Radio.Group>
                </Form.Item>
              </div>
            ) : compensation == "flatFee" ? (
              <Form.Item
                name="flatFee"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input placeholder="Enter Flat Fee" />
              </Form.Item>
            ) : null}
          </div>
          <Form.Item
            name="radio5"
            rules={[{ required: true, message: "required!" }]}
          >
            <Radio.Group>
              <Radio value="independent_compensation">
                This compensation is independent of and in addition to the ($/%)
                offer of compensation made by the LISTING BROKER to the BUYER'S
                BROKER
              </Radio>

              {radioValue === "independent_compensation" && (
                <Flex gap={0} align="center">
                  <Form.Item
                    name="additonal_cost_compensation"
                    rules={[{ required: true, message: "required!" }]}
                  >
                    <Input placeholder="Enter Cost" style={{ width: "90%" }} />
                  </Form.Item>

                  <Form.Item
                    name="cost_type"
                    rules={[{ required: true, message: "required!" }]}
                  >
                    <Radio.Group>
                      <Radio value="$">Dollar</Radio>
                      <Radio value="%">Percentage</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Flex>
              )}

              <Radio value="no_offer_compensation">
                There is no offer of compensation made by the LISTING BROKER to
                the BUYER'S BROKER or that offer was rejected.
              </Radio>
            </Radio.Group>
          </Form.Item>
          <div style={{ marginTop: "10px" }}>
            <label className="form-title" for="additionalTerms">
              Lead Paint Disclosure Needed?
            </label>
            <Form.Item
              name="leadPiantDisclosure"
              rules={[{ required: true, message: "required!" }]}
              initialValue={"yes"}
            >
              <Radio.Group>
                <Radio value="yes">Yes</Radio>
                <Radio value="no">No</Radio>
              </Radio.Group>
            </Form.Item>
          </div>
          <Checkbox
            onChange={(e) => setRepresentation(e.target.checked)}
            style={{ marginBottom: "5px" }}
          >
            Representation/Acknowledgements
          </Checkbox>
          {representation && (
            <>
              <Form.Item
                name="RepresentationOrAcknowledgements"
                rules={[{ required: true, message: "required!" }]}
              >
                <TextArea
                  rows={2}
                  placeholder="Representation/Acknowledgements"
                  style={{ marginTop: "0.5rem" }}
                />
              </Form.Item>
            </>
          )}

          <br />

          <Checkbox
            onChange={(e) => setAddAddendum(e.target.checked)}
            style={{ marginBottom: "5px" }}
          >
            Add Addendum
          </Checkbox>
          {addAddendum && (
            <>
              <Row justify="space-evenly">
                <Col xs={22} md={7}>
                  <label className="form-title">
                    Units to be delivered Vacant
                  </label>
                  <Form.Item name="units_delivered_vacant">
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={22} md={7}>
                  <label className="form-title">Seller Credit Amount</label>
                  <Form.Item name="sellet_credit_amount">
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={22} md={7}>
                  <label className="form-title">
                    Compensation to Buyer's Broker %
                  </label>
                  <Form.Item name="compensation_buyers_broker">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <div>
                <label className="form-title" style={{ marginLeft: 40 }}>
                  Other Contingencies{" "}
                  <span style={{ fontSize: 16 }}>
                    (Fill in contingency needed)
                  </span>
                </label>
                <Row justify="space-evenly">
                  <Col xs={22} md={7}>
                    <Form.Item name="b_contingencies" label="B">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={22} md={7}>
                    <Form.Item name="c_contingencies" label="C">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={22} md={7}>
                    <Form.Item name="d_contingencies" label="D">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={22} md={7}>
                    <Form.Item name="e_contingencies" label="E">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={22} md={7}>
                    <Form.Item name="f_contingencies" label="F">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={22} md={7}>
                    <Form.Item name="g_contingencies" label="G">
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            </>
          )}

          <div style={{ marginTop: "10px" }}>
            <label className="form-title" for="additionalTerms">
              Additional terms
            </label>
            <Form.Item name="additionalTerms">
              <TextArea
                rows={2}
                placeholder="Additional terms"
                style={{ marginTop: "0.5rem" }}
              />
            </Form.Item>
          </div>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form>
      </div>
    </Content>
  );
};

export default Register;
